import { EmailTemplates } from './mailer.model';

export enum SendOTPKeys {
  email = 'email',
  bcc = 'bcc',
  duration = 'duration',
  emailTemplate = 'emailTemplate',
  subject = 'subject',
  otpRef = 'otpRef',
  consumedDate = 'consumedDate',
  isConsumed = 'isConsumed',
  isPermanent = 'isPermanent',
}

export interface SendOTP {
  [SendOTPKeys.duration]: 5 | 30 | 120 | 1440;
  [SendOTPKeys.email]: string;
  [SendOTPKeys.subject]: string;
  [SendOTPKeys.bcc]?: string[];
  [SendOTPKeys.otpRef]: string;
  [SendOTPKeys.emailTemplate]:
    | EmailTemplates.confirmEmailUpdateTmp
    | EmailTemplates.confirmRegisterEmailTmp
    | EmailTemplates.confirmPasswordUpdateTmp
    | EmailTemplates.permanentOTP;
  [SendOTPKeys.isConsumed]?: boolean;
  [SendOTPKeys.isPermanent]?: boolean;
  [SendOTPKeys.consumedDate]?: string;
}
